// Admin Dashboard Routes
import ApprovalRequests from './approvalRequests'
import ChangePin from './changePin'
// import DashboardOverview from './dashboard/overview'
import DashboardFeatures from './dashboard/features'
import DashboardDemographics from './dashboard/demographics'
import DashboardDemographicsTestimonies from './dashboard/demographics/testimonies'
import DashboardDemographicsFaqs from './dashboard/demographics/faq'
import DashboardDemographicsNews from './dashboard/demographics/news'
import DashboardDemographicsBlog from './dashboard/demographics/blog'
import DashboardDemographicsPartners from './dashboard/demographics/partners'
import DashboardDemographicsFeaturedPlacements from './dashboard/demographics/featuredPlacements'
import DashboardDemographicsAuthPages from './dashboard/demographics/authPages'
import CategoryAnalytics from './dashboard/features/categoryAnalytics'
import AddOrEditCategory from './dashboard/features/addOrEditCategory'
import EditProfile from './editProfile'
import Login from './login'
import SignOut from './signOut'
import Users from './users'
import Spirituality from './spirituality'
import SocialFeed from './socialFeed'
import AdminMatrimonialCreate from './userAdmin/matrimonial/adminCreate'
import AdminMatrimonialPendingRefs from './userAdmin/matrimonial/pendingReferences'
import AdminJobCreate from './admin/jobs/adminCreate'
import AdminResumeCreate from './admin/resume/adminCreate'
import ActivityAnalytics from './admin/activityAnalytics'
import ReferralTracking from './admin/referralTracking'
import PushNotifications from './admin/pushNotifications'
import NewsFeedSettings from './admin/newsFeedSettings'
import SocialMediaSettings from './admin/socialMediaSettings'
import PendingNews from './admin/pendingNews'
import AadhaarVerification from './aadhaarVerification'
import CRMDashboard from './crm/dashboard'
import CallManagement from './crm/calls'
import Contacts from './crm/contacts'
import BusinessesMasterData from './admin/businesses'
import AdminEvents from './admin/events'
// User Admin Routes
import ChangeUserPin from './userAdmin/changePin'
import EditUserProfile from './userAdmin/editProfile'
import Listings from './userAdmin/business/listings'
import AddOrEditListing from './userAdmin/business/listings/addOrEditListing'
import Business from './userAdmin/business'
import MembershipFees from './admin/settings/membershipFees'
import ViewBusinessLeads from './userAdmin/business/viewLeads'
import RegisterBusiness from './userAdmin/business/register'
import Notifications from './userAdmin/notifications'
import ViewLeads from './userAdmin/business/listings/viewLeads'
import Subscription from './userAdmin/subscription'
import MemberShipCard from './userAdmin/memberShipCard'

import * as Layout from 'layouts'
// import { auth } from 'api'
// import { socialFeed } from 'api/public'

const dashboardRoutes = [
  {
    path: '/admin/settings/membership-fees',
    Component: MembershipFees,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/approvalRequests',
    Component: ApprovalRequests,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/pushNotifications',
    Component: PushNotifications,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/newsFeedSettings',
    Component: NewsFeedSettings,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/socialMediaSettings',
    Component: SocialMediaSettings,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/pendingNews',
    Component: PendingNews,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/matrimonial/create',
    Component: AdminMatrimonialCreate,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/jobs/create',
    Component: AdminJobCreate,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/resume/create',
    Component: AdminResumeCreate,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/matrimonial/pendingReferences',
    Component: AdminMatrimonialPendingRefs,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/changePin',
    Component: ChangePin,
    Super: Layout.Admin,
    auth: true
  },
  // {
  //   path: '/admin/dashboard/overview',
  //   Component: DashboardOverview,
  //   Super: Layout.Admin,
  //   auth: true
  // },
  {
    path: '/admin/dashboard/features',
    Component: DashboardFeatures,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/features/category/:categoryId',
    Component: CategoryAnalytics,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/features/category/:categoryId/editCategory',
    Component: AddOrEditCategory,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics',
    Component: DashboardDemographics,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/success-stories',
    Component: DashboardDemographicsTestimonies,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/faq',
    Component: DashboardDemographicsFaqs,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/partners',
    Component: DashboardDemographicsPartners,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/featured-placements',
    Component: DashboardDemographicsFeaturedPlacements,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/auth-pages',
    Component: DashboardDemographicsAuthPages,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/news',
    Component: DashboardDemographicsNews,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/dashboard/demographics/blog',
    Component: DashboardDemographicsBlog,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/editProfile',
    Component: EditProfile,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/login',
    Component: Login,
    auth: false
  },
  {
    path: '/signOut',
    Component: SignOut,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/users',
    Component: Users,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/aadhaarVerification',
    Component: AadhaarVerification,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/users/addUser',
    Component: EditUserProfile,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/spirituality',
    Component: Spirituality,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/socialFeed',
    Component: SocialFeed,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/analytics/activity',
    Component: ActivityAnalytics,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/analytics/referrals',
    Component: ReferralTracking,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/crm',
    Component: CRMDashboard,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/crm/calls',
    Component: CallManagement,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/crm/contacts',
    Component: Contacts,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/businesses',
    Component: BusinessesMasterData,
    Super: Layout.Admin,
    auth: true
  },
  {
    path: '/admin/events',
    Component: AdminEvents,
    Super: Layout.Admin,
    auth: true
  }
]

const userAdminRoutes = [
  {
    path: '/userAdmin/editProfile',
    Component: EditUserProfile,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/editProfile/changePin',
    Component: ChangeUserPin,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/:businessId/listings',
    Component: Listings,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/:businessId/listings/addListing',
    Component: AddOrEditListing,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/:businessId/listings/editListing/:listingId',
    Component: AddOrEditListing,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses',
    Component: Business,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/viewLeads/:businessId',
    Component: ViewBusinessLeads,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/editBusiness/:partNo/:businessId',
    Component: RegisterBusiness,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/registerBusiness/:partNo',
    Component: RegisterBusiness,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/businesses/listings/viewLeads/:listingId',
    Component: ViewLeads,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/notifications',
    Component: Notifications,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/subscription',
    Component: Subscription,
    Super: Layout.UserAdmin,
    auth: true
  },
  {
    path: '/userAdmin/memberShipCard',
    Component: MemberShipCard,
    Super: Layout.UserAdmin,
    auth: true
  }
]

const routes = [...dashboardRoutes, ...userAdminRoutes]

export default routes
